import React from 'react';

import HintPopover from "../hint-popover/hint-popover";
import ProjectIconUI5 from "../../../core/gd-ui/project-icon/project-icon-ui5";
import ProjectSession from "../../model2/project/project-session";

type Props = {

    className?  : string

    projectId   : ID
    params?     : any

    name?       : string
    type?       : 'default' | 'ui5' | 'ui5-prop' | 'my-work' | 'with-icon'  // 'name-only',
    hintFullPath?: boolean   // if true show full path not just name

    onClick?    : callback
};


export default class GDProjectName extends React.Component<Props> {

    // static propTypes = {
    //
    //     projectId: PropTypes.string,
    //     params: PropTypes.object,
    //
    //     name: PropTypes.string,
    //     type: PropTypes.oneOf(['default', 'ui5', 'ui5-prop', 'my-work', 'with-icon']),  // 'name-only',
    //     hintFullPath: PropTypes.bool,   // if true show full path not just name
    //
    //     onClick: PropTypes.func
    // };

    static defaultProps = {
        type: 'default',
        hintFullPath: true
    };

    onClick = (e:React.SyntheticEvent) => {
        if (this.props.onClick && !gd.isSharedView) {
            e.stopPropagation();
            if (this.props.projectId) {
                // @ts-ignore
                this.props.onClick(this.props.projectId); // not sure why we need projectId
            }
        }
    }

    getHint = () => {

        let res = this.props.name;

        if (this.props.projectId) {
            const project : ProjectSession = gd.session.projects.get(this.props.projectId)!

            if (this.props.hintFullPath) {
                // @ts-ignore
                const parents = gd.tree.findProjectParents(gd.tree.getProject(this.props.projectId)).concat(project).map((p:any) => p.name);
                res = parents.join(' / ');

            } else {
                res = project.name;
            }
        }

        return res;
    }

    render() {
        const project = gd.session.projects.get(this.props.projectId);
        if (!project) return null

        let classes

        switch (this.props.type) {

            case 'ui5-prop':
                // "gd-project-name",
                classes = Classes('ui5-prop gray', this.props.className);
                break

            default:
                classes = Classes("gd-project-name", this.props.type+'-type', this.props.className,{
                    'ui5-property': this.props.type === 'ui5'
                });
                break
        }



        const iconSize = _.get(this.props.params,'iconSize', '13')
        const iconClassName = _.get(this.props.params,'iconClassName', 'm-r-5')

        return (
            <div className={classes} onClick={this.onClick}>
                {this.props.type === 'with-icon' &&
                    <ProjectIconUI5 className={iconClassName} size={iconSize} projectId={this.props.projectId} colorize={true}/>
                }
                <div className="ui5-txt-not-important-tiny txt-truncate">{project.name}</div>
                <HintPopover parent={this} hint={this.getHint()} multiline={true}/>
            </div>
        );
    }
}